import { render, staticRenderFns } from "./ContainerFormQuestion.vue?vue&type=template&id=df9d3f5c"
import script from "./ContainerFormQuestion.vue?vue&type=script&lang=js"
export * from "./ContainerFormQuestion.vue?vue&type=script&lang=js"
import style0 from "./ContainerFormQuestion.vue?vue&type=style&index=0&id=df9d3f5c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports